const doc = [({"da":({"js":({"merfoto":({"albums":({"index":({"no_accessible_albums_were_found":"Der blev ikke fundet nogen tilgængelige albums."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;